import { createStructuredSelector } from 'reselect'

import {
  SANCTION_DETAIL,
  SANCTION_DETAIL_SUCCESS,
  SANCTION_DETAIL_ERROR,
  SANCTION_VIEW_MODAL_SET,
} from '../actions';

export const NAME = 'sanction';

export const SanctionDetail = (data) => ({
  type: SANCTION_DETAIL,
  payload: data
});

export const SanctionDetailSuccess = (data) => ({
  type: SANCTION_DETAIL_SUCCESS,
  payload: data
});

export const SanctionDetailError = (error) => ({
  type: SANCTION_DETAIL_ERROR,
  payload: error
});

export const SanctionViewModalSet = (data) => ({
  type: SANCTION_VIEW_MODAL_SET,
  payload: data
});

const sanction = (state) => state[NAME];
export const SanctionSelector = createStructuredSelector({
  sanction
})
